export function fontLicense() {
  new window.Image().src =
    'https://fast.fonts.com/t/1.css?apiType=css&projectid=33bd0973-5b82-45be-bb77-837225874dfe';
}
